import React from "react";

class UploadedFile{
    constructor(fileName, type, data) {
        this.fileName = fileName
        this.type = type
        this.dataUrl = data
    }

    get base64(){
        return this.dataUrl.substring(this.dataUrl.indexOf(',') + 1)
    }
}

export default class extends React.Component{
    constructor(props) {
        super(props);
        this.ref = React.createRef()
        this.open = () => this.ref.current.click()
        this.fileSelected = () => {
            if (!this.props.onSelected){
                return
            }
            const fileReader = new FileReader(), file = this.ref.current.files[0]
            fileReader.addEventListener('load', () => {
                this.props.onSelected(new UploadedFile(
                    file.name,
                    file.type,
                    fileReader.result
                ));
            })
            fileReader.readAsDataURL(this.ref.current.files[0])
        }
    }

    render() {
        const {children, onSelected, ...props} = this.props
        return <>
            <input
                {...props}
                ref={this.ref}
                type="file"
                style={{
                    position: "fixed",
                    visibility: "hidden",
                    top: "-100vw",
                    left: "-100vw"
                }}
                onChange={this.fileSelected}
            />
            {children(this.open)}
        </>
    }
}
